import Http from "../services/http";

import { ApiRoutes } from "../common/apiRoutes";

const objectToQueryString = (obj: any) => {
  const keyValuePairs = Object.keys(obj).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
  return keyValuePairs.join('&');
}

export const getReportsAPI = (id: any, data: any) => {
  return Http.get(`report/${id}?${objectToQueryString(data)}`);
};